import React, { useEffect, useState } from "react";
import IdentityDoc from "../components/Element/IdentityDocuments";
import Profilesidebar from "../components/Element/Profilesidebar";
import { connect } from "react-redux";
// import ProjectTable from "../services/TableGlobal";
import ProfileSideBarMobile from "../components/Element/ProfileSideBarMobile";
import { isMobileOrLaptop } from "../services/CheckDevice";

const IdentityDocument = (props) => {
  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {checkDevice && checkDevice == "Mobile" ? (
                  <ProfileSideBarMobile page="identity-document" />
                ) : (
                  <Profilesidebar page="identity-document" />
                )}
                <div className="col-xl-9 col-lg-8 m-b30">
                  <IdentityDoc deviceInfo={checkDevice} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    identityDocuments: state.identityDocuments.identityDocuments,
  };
};

export default connect(mapStateToProps)(IdentityDocument);
